import React, { useContext } from 'react'
import { LoadingPageContext } from './LoadingPageContext'

/**
 * This component loads through context a different loading page based on the current
 * route.
 * See RouteBasedLoadingPage.tsx to configure what loading page to use for
 * your route.
 */
export const DynamicLoadingPage = () => {
  const { component: Component } = useContext(LoadingPageContext)
  return <Component />
}
